import { Dialog, DialogContent, DialogTitle } from "@mui/material"
import { PaperArrastavel } from "../dialog-arrastavel/PaperArrastavel"
import React, { ReactNode } from "react"
const estiloSelecionarColunasParaExibicao = require('./selecionarColunasParaExibicao.module.scss').default
import * as R from 'ramda'

export type Coluna = {
    nome:string
    selecionada:boolean
    colunaOriginal:any
}

export type SelecionarColunasParaExibicaoProps = {
    mostrar: boolean
    colunas: Coluna[]
    funcaoOrdenacao?: (coluna1:Coluna, coluna2:Coluna) => number
    funcaoTraducaoNome?:(coluna:Coluna) => string
    onClose: () => void
    onToggleColunaSelecionada: (coluna:Coluna, selecionada: boolean) => void
    onToggleSelecionarTodasColunas: (selecionar:boolean) => void
}


export const SelecionarColunasParaExibicao = (props: SelecionarColunasParaExibicaoProps) => {

    const ordenar = (coluna1: Coluna, coluna2: Coluna) => props.funcaoOrdenacao != null ? props.funcaoOrdenacao(coluna1, coluna2) : 0

    const traduzirNome = (coluna:Coluna) => props.funcaoTraducaoNome != null ? props.funcaoTraducaoNome(coluna) : coluna.nome

    return <>
        <Dialog open={props.mostrar} onClose={props.onClose} PaperComponent={PaperArrastavel}>
            <DialogTitle>
                Selecionar colunas para exibição
            </DialogTitle>
            <DialogContent>
                <div className={estiloSelecionarColunasParaExibicao.container1}
                    id="SelecionarColunasParaExibicao_container1_SelecionarTodasColunas"
                    key="SelecionarColunasParaExibicao_container1_SelecionarTodasColunas"
                >
                    <div className={estiloSelecionarColunasParaExibicao.container2}
                        id="SelecionarColunasParaExibicao_container2_SelecionarTodasColunas"
                        key="SelecionarColunasParaExibicao_container2_SelecionarTodasColunas"
                    >
                        <div className="_mr-4"
                            id="SelecionarColunasParaExibicao_Div_SelecionarTodasColunas"
                            key="SelecionarColunasParaExibicao_Div_SelecionarTodasColunas"
                        >
                            <input
                                type="checkbox"
                                id="SelecionarColunasParaExibicao_checkboxSelecionarTodasColunas"
                                key="SelecionarColunasParaExibicao_checkboxSelecionarTodasColunas"
                                checked={(props.colunas ?? []).every(c => c.selecionada)}
                                onChange={e => props.onToggleSelecionarTodasColunas(e.target.checked)}
                                />
                        </div>

                        <b>Todas</b>
                    </div>
                </div>

                {R.sort(ordenar,props.colunas).map(coluna => <div
                    className="_flex _flex-row _justify-start _max-w-xs _items-end"
                    id={`SelecionarColunasParaExibicao_Div1_${coluna.nome}`}
                    key={coluna.nome}>
                    <div className="_mr-4"
                        id={`SelecionarColunasParaExibicao_Div_${coluna.nome}`}
                        key={`SelecionarColunasParaExibicao_Div_${coluna.nome}`}
                    >
                        <input
                            type="checkbox"
                            id={`SelecionarColunasParaExibicao_checkbox_${coluna.nome}`}
                            key={`SelecionarColunasParaExibicao_checkbox_${coluna.nome}`}
                            checked={coluna.selecionada ?? false}
                            onChange={() => props.onToggleColunaSelecionada(coluna,!coluna.selecionada)}
                            />
                    </div>

                    {traduzirNome(coluna)}
                </div>)}
                
                
            </DialogContent>
        </Dialog>
    </>
}